module.exports = __webpack_public_path__ + "img/black.a1ec3df3.svg";